export interface Client extends ClientDocument {
  documentID: string;
}

export interface ClientDocument {
  primaryContact: ClientContact;
  contacts: ClientContact[];
  aircrafts: ClientAircraft[];
}

export interface ClientContact {
  isPrimary: boolean;
  title: string;
  firstName: string;
  lastName: string;
  address: string;
  email: string;
  phone: string;
  jobTitle: string;
  company?: ClientContactCompany;
}

export interface ClientContactCompany {
  name: string;
  address: string;
  website: string;
  fax?: string;
  email?: string;
  phone?: string;
}
export interface ClientAircraft {
  aircraftID: string;
  ownershipType: CLIENT_AIRCRAFT_OWNERSHIP_TYPES;
  fractionalData?: ClientAircraftFractionalData;
}

export enum CLIENT_AIRCRAFT_OWNERSHIP_TYPES {
  FRACTIONAL,
  WHOLE,
}

export interface ClientAircraftFractionalData {
  percent: number; // 0 to 1
  expiration: Date;
}
